<div #triggerBtn class="universal-callback-button" [ngClass]="{'mob-button' : isMobile}"
     (click)="openUniversalCallback()">
  <div *ngIf="!open && !openQChat" inlineSVG="assets/img/universal-callback/MessengerNewWhite.svg"></div>
  <svg *ngIf="open || openQChat" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.2067 26.2067L8.5 8.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M26.2067 8.5L8.5 26.2067" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <div *ngIf="unreadMessages > 0" class="unread-badge">
    {{ unreadMessages }}
  </div>
</div>

<div class="universal-callback-button-dialog">
  <p-dialog [(visible)]="open" [modal]="false" [draggable]="false" [resizable]="false"
            [showHeader]="false" styleClass="dialog-universal-button" (onHide)="removeClass()">
    <div class="consult-title">{{ 'Есть вопрос?' | translate }}</div>
    <div class="consult-title">{{ 'Напишите нам в чат' | translate }}</div>
    <div class="btn-consult-group">
      <div class="btn-consult" (click)="openRocketChat()">
        <div class="btn-consult-img" inlineSVG="assets/img/universal-callback/JivositeNew.svg"></div>
        {{ 'Онлайн-чат' | translate }}
      </div>
      <div class="btn-consult" (click)="openWhatsApp()">
        <div class="btn-consult-img" inlineSVG="assets/img/universal-callback/WhatsAppNew.svg"></div>
        {{ 'WhatsApp' }}
      </div>
      <div class="btn-consult" (click)="openTelegramBot()">
        <div class="btn-consult-img" inlineSVG="assets/img/universal-callback/TelegramNew.svg"></div>
        {{ 'Telegram' }}
      </div>
    </div>
    <div class="faq-btn" (click)="openHelpCenter()">
      {{ 'Часто задаваемые вопросы' | translate }}
      <div class="ml-auto" inlineSVG="assets/img/universal-callback/RightArrow.svg"></div>
    </div>
    <div *ngIf="open" class="down-arrow" inlineSVG="assets/img/universal-callback/DownArrow.svg"></div>
  </p-dialog>

  <div class="q-chat-dialog" [class.visible]="openQChat">
    <div class="q-chat-content">
      <div class="close-row">
        <button (click)="closeQChat()">
          <svg width="16" height="16" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.2067 26.2067L8.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M26.2067 8.5L8.5 26.2067" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="q-chat"></div>
    </div>
  </div>
</div>
